import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { spacing0 } from 'src/styles/spacing';

export const StyledOrderedListElement = styled(Typography)`
  padding-left: ${spacing0};
`;
